export default __webpack_public_path__ + "static/media/Featured-2.dba0f040.jpg";